import React, { PureComponent } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import css from './index.scss';
import { Forward } from '../../helpers/icon-dictionary';
import SvgIcon from '../svg-icon/svg-icon';

class CourseBadge extends PureComponent {
    render() {
        const { children, background, disabled } = this.props;
        const childElement = children ? (<div className={css.children}>{children}</div>) : '';
        const badgeStyle = disabled ? `${css.container} ${css.disabled}` : `${css.container}`;

        return (<div className={badgeStyle} style={{ background: `${background}` }}>
            {childElement}
            <div className={css.forwardButton}><SvgIcon icon={Forward} /></div>
        </div>);
    }
}

CourseBadge.propTypes = {
    children: PropTypes.node,
    background: PropTypes.string,
    disabled: PropTypes.bool
};

export default injectIntl(styleable(css)(CourseBadge));




// WEBPACK FOOTER //
// ./app/components/course-badge/index.js